import { PieChart } from "@mui/x-charts";
import {
  GlobalConfiguration,
  SettingsStatisticsConfiguration,
} from "../../../../../utils/configurationProvider";
import { useSelector } from "react-redux";

const CommonPieChart = ({ dataArray, isMobile }) => {
  const services = useSelector((state) => state.refreshToken.services);
  const globalStatisticsService = services?.includes("VStatistics");

  const seriesData = {
    series: [
      {
        id: "outer",
        paddingAngle: SettingsStatisticsConfiguration.pieChartPaddingAngle,
        startAngle: SettingsStatisticsConfiguration.pieChartStartAngle,
        endAngle: SettingsStatisticsConfiguration.pieChartEndAngle,
        innerRadius: isMobile
          ? SettingsStatisticsConfiguration.pieChartInnerRadiusMobile
          : SettingsStatisticsConfiguration.pieChartInnerRadius,
        outerRadius: isMobile
          ? SettingsStatisticsConfiguration.pieChartOuterRadiusMobile
          : SettingsStatisticsConfiguration.pieChartOuterRadius,
        data: dataArray.filter(
          (graphData) => graphData.value > GlobalConfiguration?.lengthCheckZero,
        ), // filtering out zero value... as MUI take padding space for 0 value... as this results in inconsistent spacing between slices.
        highlightScope: globalStatisticsService
          ? { fade: "global", highlight: "item" }
          : { fade: "none", highlight: "none" },
        arcLabel: () => "",
      },
    ],

    slotProps: {
      legend: { hidden: true },

      popper: {
        modifiers: [
          { name: "offset", options: { offset: [0, isMobile ? 12 : 0] } },
          {
            name: "flip",
            enabled: true,
            options: { fallbackPlacements: ["top", "bottom", "right"] },
          },
          {
            name: "preventOverflow",
            options: { boundary: "viewport", padding: 8 },
          },
        ],
      },
    },
    margin: {
      top: SettingsStatisticsConfiguration.zeroStrokeWidthForLineGraph,
      right: SettingsStatisticsConfiguration.zeroStrokeWidthForLineGraph,
      bottom: SettingsStatisticsConfiguration.zeroStrokeWidthForLineGraph,
      left: SettingsStatisticsConfiguration.zeroStrokeWidthForLineGraph,
    },
  };

  return (
    <div className="flex justify-center items-center w-full-width">
      <PieChart
        {...seriesData}
        skipAnimation={!globalStatisticsService}
        tooltip={{ trigger: !globalStatisticsService ? "none" : "item" }}
        sx={{
          "cursor": !globalStatisticsService ? "not-allowed" : "default",
          "& .MuiPieArc-root": { stroke: "none" },
          '& [data-series-id="outer"] .MuiPieArc-root': {
            opacity: "var(--light-opacity)",
          },
        }}
        height={
          isMobile
            ? SettingsStatisticsConfiguration.pieChartHeightMobile
            : SettingsStatisticsConfiguration.pieChartHeight
        }
      />
    </div>
  );
};

export default CommonPieChart;
